import {
  mapZipcodeToState,
  StatusTypes,
  getReportInvitationStatusDecision,
  getAggregateScreeningStatus,
  shouldDisplayAssessAndScreeningStatuses,
  shouldDisplayAssessAndReportStatuses,
} from '@dashboard-experience/utils';
import { Report } from '../../../types/report';
import { computeSearchesStatus } from './lib/status';

/**
 * Maps a zipcode to a state name string
 * @param zipcode The zipcode to map to a state
 * @returns The state name or '-' if not found
 */
export const getStateNameFromZipcode = (
  zipcode: string | null | undefined,
): string => {
  if (typeof zipcode !== 'string' || !/^\d{5}$/.test(zipcode)) {
    return '-';
  }
  try {
    return mapZipcodeToState(zipcode).state_name || '-';
  } catch {
    return '-';
  }
};

export const getStatusTypeAndReportLevelStatuses = (
  report: Report | null | undefined,
) => {
  const statusType =
    report?.assessment && typeof report?.assessment !== 'string'
      ? StatusTypes.Assess
      : StatusTypes.Legacy;

  const status =
    statusType === StatusTypes.Assess
      ? getReportInvitationStatusDecision(report, StatusTypes.Assess)
      : report?.status;

  const secondaryStatus =
    statusType === StatusTypes.Assess &&
    shouldDisplayAssessAndReportStatuses(report, status)
      ? report?.status
      : null;

  return { statusType, status, secondaryStatus };
};

export const hasAssessment = (search: any) => {
  if (Array.isArray(search)) {
    return search.some(hasAssessment);
  }
  return search?.assessment && !(typeof search?.assessment === 'string');
};

export const getScreeningStatusAndAssessment = (
  assessmentEnabled: boolean,
  useScreeningStatusOverAssessment: boolean,
  search: any,
  status: null | string = null,
) => {
  if (!search) {
    return {
      searchStatus: null,
      statusType: StatusTypes.Legacy,
      secondaryStatus: null,
    };
  }

  let searchStatus = Array.isArray(search)
    ? computeSearchesStatus(search)
    : search.status;
  let statusType = StatusTypes.Legacy;
  let secondaryStatus = null;

  if (assessmentEnabled && hasAssessment(search)) {
    statusType = StatusTypes.Assess;
    searchStatus = status || getAggregateScreeningStatus(search, statusType);

    if (shouldDisplayAssessAndScreeningStatuses(search.status, searchStatus)) {
      secondaryStatus = search.status;
    }

    if (useScreeningStatusOverAssessment) {
      searchStatus = search.status;
    }
  }

  return { searchStatus, statusType, secondaryStatus };
};

export const chargesAssessmentToDashboardFormat = (charges: any[]) => {
  if (!charges) return [];
  return charges.map((charge: any) => {
    return {
      assessment:
        charge.assessment && typeof charge.assessment === 'string'
          ? {
              display: {
                decision: charge.assessment,
              },
            }
          : null,
    };
  });
};
